module.exports = __webpack_public_path__ + "img/schoolicon.2fec03fb.png";